import { ArrowRight, Store } from "lucide-react";
import { Link } from "react-router-dom";

export default function HardwarePartnersSection() {
  const partners = [
    {
      name: "Velodepo",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Velodepo%20GmbH.jpg-W25ovGt2HkMdXl4b1zOwwToHUIQarO.jpeg",
    },
    {
      name: "Greenguard",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Greenguard%20Logo-wpEHkmxQYrttYx0LCOw7zuYCcX5GFA.png",
    },
    {
      name: "Fietshangar",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Fietshangar%20Logo-e6K5CwEeUNVcfbMcjf010coy77tJ7z.png",
    },
    {
      name: "EMZ",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/EMZ%20LOGO-M3oswGYoee0IyxqMgWP2MGfg8nsRzz.png",
    },
    {
      name: "Kaluu",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/kaluu%20logo-rdmuJeK8STt5qGc8Wm3jnktxNj9p0N.png",
    },
    {
      name: "Bike.box",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Bike.box%20logo-Z9HlQWCGCZbo9AJPqQDGn4H5INrm6T.png",
    },
    {
      name: "Koch & Partner",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Koch%20und%20Partner-ljKKzsTLmXeCorZsp64BuOpoQIheRX.png",
    },
    {
      name: "ChargeSafe",
      logo: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/ChargeSafe-RoUB4PMH0DpfgmWNtdsI6WfSJSCfAy.png",
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-purple-100 to-blue-100 text-purple-800 mb-6">
            <Store className="w-4 h-4 mr-2" />
            <span className="text-sm font-medium">Hardware-Ökosystem</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Unsere Hardware-Partner
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            JUHUU arbeitet mit führenden Herstellern zusammen, um Ihnen die
            beste Hardware-Auswahl zu bieten
          </p>
        </div>

        {/* Partner Logos with Horizontal Scrolling Animation */}
        <div className="relative mb-12 overflow-hidden">
          {/* Decorative overlay background */}
          <div className="absolute inset-0 bg-gradient-to-r from-purple-100/50 via-blue-100/50 to-indigo-100/50 rounded-3xl transform -rotate-1"></div>
          <div className="absolute inset-0 bg-gradient-to-l from-blue-100/30 via-purple-100/30 to-pink-100/30 rounded-3xl transform rotate-1"></div>

          {/* Main container */}
          <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-white/50">
            <div className="flex overflow-scroll">
              {/* First set of logos */}
              {[...partners, ...partners].map((partner, index) => (
                <div
                  key={`first-${index}`}
                  className="flex-shrink-0 bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 border border-gray-100 mx-4 min-w-[200px]"
                >
                  <img
                    src={partner.logo || "/placeholder.svg"}
                    alt={`${partner.name} Logo`}
                    width={160}
                    height={80}
                    className="mx-auto mb-3 h-16 w-auto object-contain"
                  />
                  <h3 className="font-medium text-gray-900 text-sm text-center">
                    {partner.name}
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Marketplace Button */}
        <div className="flex justify-center mb-16">
          <Link
            to="/marketplace"
            className="group relative inline-flex items-center justify-center px-8 py-4 overflow-hidden rounded-full bg-gradient-to-r from-purple-600 to-blue-600 text-white font-medium shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-80 group-hover:h-80 opacity-10"></span>
            <span className="relative flex items-center">
              Alle Partner im Marketplace entdecken
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-800 mb-6">
                <Store className="w-4 h-4 mr-2" />
                <span className="text-sm font-medium">
                  Herstellerunabhängig
                </span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Herstellerunabhängige Integration
              </h3>
              <p className="text-gray-600 mb-6">
                JUHUU funktioniert mit Hardware aller führenden Hersteller.
                Unsere offene Plattform ermöglicht es Ihnen, die beste Hardware
                für Ihre spezifischen Anforderungen zu wählen, ohne an einen
                Anbieter gebunden zu sein.
              </p>
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="h-2 w-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">
                    Autarke Bluetooth-Schließsysteme ohne externe
                    Stromversorgung
                  </span>
                </div>
                <div className="flex items-center">
                  <div className="h-2 w-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">
                    Mobilfunk-Anbindung von Steuerungen und Sensoren
                  </span>
                </div>
                <div className="flex items-center">
                  <div className="h-2 w-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">
                    Solar-betriebene Systeme
                  </span>
                </div>
                <div className="flex items-center">
                  <div className="h-2 w-2 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full mr-3"></div>
                  <span className="text-gray-700">
                    Nachrüst-Module für bestehende Anlagen
                  </span>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-blue-300 to-indigo-300 rounded-full opacity-30 blur-2xl"></div>
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Herstellerunabh%C3%A4ngig-nZZ9Lh5PnoywI48KzjXhNWUMdze1sH.png"
                alt="Herstellerunabhängige Integration"
                width={500}
                height={300}
                className="rounded-lg shadow-lg relative z-10 w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
